"use client";

import { useRetailerHomePage } from "@/providers/strapi/content/types/singleTypes/retailer-home-page";
import * as X from "@/ui";
import ReactMarkdown from "react-markdown";


// const data = {
//   questions: [
//     {
//       title: {
//         en: "What is tax-free shopping?",
//         fr: `Qu’est-ce que la vente en détaxe ?`,
//       },
//       answer: {
//         en: (
//           <article>
//             <p>Tax-free shopping allows retailers in the European Union (EU) to offer their international customers the possibility to get back the VAT paid on their purchases.</p>
//             <p>This service is a real driver for customer acquisition and growth, helping attract more travelers and boost sales.</p>
//             <p>Who is eligible? Only customers residing outside the EU, such as international travelers, French expatriates living abroad, etc. are eligible for tax-free shopping.</p>
//           </article>
//         ),
//         fr: (
//           <>
//             <p>La vente en détaxe permet aux commerçants de l’Union européenne (UE) d’offrir à leurs clients internationaux la possibilité de récupérer la TVA payée sur leurs achats en boutique.</p>
//             <p>Ce service est un véritable levier de recrutement et de croissance, en attirant plus de voyageurs et en boostant les ventes.</p>
//             <p>Qui peut en bénéficier{X.Nbsp}? Seuls les clients résidant hors de l’UE – voyageurs internationaux, expatriés français vivant à l’étranger, etc. – sont éligibles à la détaxe</p>
//           </>
//         ),
//       },
//     },
//     {
//       title: {
//         en: "How does Zapptax work?",
//         fr: `Comment fonctionne Zapptax ?`,
//       },
//       answer: {
//         en: (
//           <article>
//             <p>With Zapptax, tax-free shopping happens in just 3 simple steps:</p>

//             <h3>1. Download &amp; register</h3>
//             <p>Your customer downloads the Zapptax app for free, signs up, and enters their travel dates.</p>

//             <h3>2. Upload invoices</h3>
//             <p>At the time of purchase, you issue a standard VAT invoice in the name of Zapptax.Your customer takes a photo of the invoice and uploads it directly via the app.</p>
//             <p>Billing addresses to use on the invoice:</p>
//             <ul>
//               <li>France: Zapptax, 23 rue Jean-Jacques Rousseau, 75001 PARIS</li>
//               <li>Belgium: Zapptax, Rue du Boulet 42, 1000 BRUSSELS – VAT: 0670 776 774</li>
//               <li>Spain: Zapptax, Bravo Murillo 52 1-3, 28003 MADRID – VAT: N0173919B</li>
//             </ul>

//             <h3>3. Validate the tax-free forms</h3>
//             <p>Once shopping is complete, your customer generates their tax-free form in the app.Before leaving the EU, they validate their tax-free-form:</p>
//             <ul>
//               <li>In France and Spain: by scanning the barcode at an electronic customs kiosk (PABLO in France, DIVA in Spain).</li>
//               <li>Or by presenting the forms to a Customs officer for manual validation</li>
//             </ul>
//             <p>Everything is managed in the app - no need to print anything.</p>
//             <p><strong>Minimum purchase thresholds for VAT refund:</strong></p>
//             <ul>
//               <li>France: €100 total over the entire stay</li>
//               <li>Belgium: €125 total over the entire stay</li>
//               <li>Spain: No minimum required</li>
//             </ul>
//             <p>Once Customs validation is confirmed, Zapptax refunds the VAT directly to the payment method chosen by the customer (bank transfer, credit card, PayPal, etc.).</p>
//           </article>
//         ),
//         fr: (
//           <article>
//             <p>Avec Zapptax, la détaxe se fait en seulement 3 étapes simples{X.Nbsp}:</p>

//             <h3>1. Téléchargement & inscription</h3>
//             <p>Votre client télécharge gratuitement l’application Zapptax, crée un compte et indique ses dates de voyage.</p>

//             <h3>2. Téléversement des factures</h3>
//             <p>Lors de l’achat, vous émettez une facture standard avec TVA au nom de Zapptax. Le client prend une photo de la facture et la téléverse directement via l’application.</p>
//             <p>Adresses de facturation à utiliser{X.Nbsp}:</p>
//             <ul>
//               <li>France{X.Nbsp}: Zapptax, 23 rue Jean-Jacques Rousseau, 75001 PARIS</li>
//               <li>Belgique{X.Nbsp}: Zapptax, Rue du Boulet 42, 1000 BRUXELLES – TVA{X.Nbsp}: 0670 776 774</li>
//               <li>Espagne{X.Nbsp}: Zapptax, Bravo Murillo 52 1-3, 28003 MADRID – TVA{X.Nbsp}: N0173919B</li>
//             </ul>

//             <h3>3. Validation des bordereaux de détaxe</h3>
//             <p>Une fois les achats terminés, le client génère son bordereau de détaxe dans l’application. Avant de quitter l’UE, il le valide{X.Nbsp}:</p>
//             <ul>
//               <li>En France et en Espagne{X.Nbsp}: en scannant le code-barres à une borne douanière électronique (PABLO en France, DIVA en Espagne).</li>
//               <li>Ou en le présentant à un agent des Douanes pour une validation manuelle.</li>
//             </ul>
//             <p>Toutes les démarches se font via l’appli – inutile d’imprimer quoi que ce soit.</p>
//             <p><strong>Montants minimums d’achat pour bénéficier de la détaxe{X.Nbsp}:</strong></p>
//             <ul>
//               <li>France{X.Nbsp}: 100 € cumulés sur l’ensemble du séjour</li>
//               <li>Belgique{X.Nbsp}: 125 € cumulés sur l’ensemble du séjour</li>
//               <li>Espagne{X.Nbsp}: aucun minimum requis</li>
//             </ul>
//             <p>Une fois la validation douanière confirmée, Zapptax rembourse la TVA directement sur le moyen de paiement choisi par le client (virement, carte, PayPal, etc.).</p>
//           </article>
//         ),
//       },
//     },
//     {
//       title: {
//         en: "Are there any service fees for the retailer?",
//         fr: `Y a t’il des frais de gestion à charge du commerçant ?`,
//       },
//       answer: {
//         en: (
//           <article>
//             <p>No.</p>
//             <p>The Zapptax tax-free service is completely free of charge for retailers.</p>
//             <p>Processing fees are deducted from the VAT amount refunded by Zapptax to your customer.</p>
//           </article>
//         ),
//         fr: (
//           <article>
//             <p>Non.</p>
//             <p>Le service de détaxe Zapptax est entièrement gratuit pour le commerçant.</p>
//             <p>Les frais de gestion sont déduits du montant de TVA remboursé par Zapptax à votre client.</p>
//           </article>
//         ),
//       },
//     },
//     {
//       title: {
//         en: "What proof of purchase should I provide to my customers?",
//         fr: `Quelle preuve d’achat dois-je fournir à mes clients ?`,
//       },
//       answer: {
//         en: (
//           <article>
//             <p>You must provide a <strong>standard VAT invoice issued in the name of Zapptax</strong>, including:</p>
//             <ul>
//               <li>The name and address of Zapptax</li>
//               <li>A description of the products</li>
//               <li>The price excluding VAT (net) and including VAT (gross)</li>
//               <li>The VAT rate and VAT amount</li>
//             </ul>
//             <p><strong>Other types of proof of purchase</strong> may also be accepted, as long as Zapptax is clearly mentioned:</p>
//             <ul>
//               <li>Cash register receipts: must include the name of Zapptax and all or part of its address.</li>
//               <li>Manual invoices: from a pre-numbered invoice booklet (e.g. Exacompta), with Zapptax's address in the billing section and the store's stamp clearly visible.</li>
//             </ul>
//           </article>
//         ),
//         fr: (
//           <article>
//             <p>La preuve d’achat doit être une facture avec TVA au nom de Zapptax, indiquant{X.Nbsp}:</p>
//             <ul>
//               <li>Le nom et l’adresse de Zapptax</li>
//               <li>Une description des produits</li>
//               <li>Le prix hors taxe (net) et TTC (brut)</li>
//               <li>Le taux et le montant de TVA</li>
//             </ul>
//             <p><strong>D’autres types de justificatifs</strong> peuvent aussi être acceptés, à condition que Zapptax y soit clairement mentionné{X.Nbsp}:</p>
//             <ul>
//               <li>Tickets de caisse{X.Nbsp}: ils doivent mentionner le nom de Zapptax et tout ou partie de son adresse.</li>
//               <li>Factures manuelles{X.Nbsp}: issues d’un carnet de factures prénumérotées (type Exacompta), avec l’adresse de Zapptax dans la section “facturation” et le tampon du magasin bien visible.</li>
//             </ul>
//           </article>
//         ),
//       },
//     },
//     {
//       title: {
//         en: "Can my customer get a VAT refund on my e-commerce store?",
//         fr: `Mon client peut-il obtenir la détaxe sur mon site e-commerce ?`,
//       },
//       answer: {
//         en: (
//           <article>
//             <p><strong>Yes, absolutely.</strong></p>
//             <p>If your customer resides outside the EU, they can place an order on your website - even before arriving in Europe - and have their purchases delivered to France, Belgium, or Spain, either to a friend’s address, their hotel, a pickup point ... and even to your store.</p>
//             <p>When they arrive in Europe, they can collect the items and carry them in their personal luggage to qualify for a VAT refund with Zapptax.</p>
//           </article>
//         ),
//         fr: (
//           <article>
//             <p><strong>Oui, c'est possible.</strong></p>
//             <p>Si votre client réside hors de l’UE, il peut commander sur votre site avant même son arrivée en Europe et faire livrer ses achats en France, Belgique ou Espagne, que ce soit chez des proches ou en point relais.</p>
//             <p>Lors de son passage en Europe, il pourra récupérer ses articles et les emporter dans ses bagages personnels.</p>
//           </article>
//         ),
//       },
//     },
//   ] as Array<{
//     title: X.Localization<string>;
//     answer: X.Localization<React.ReactNode>;
//   }>,
// };


export function FeaturedFaqSection(props: X.PageProps) {
  // const tr = X.useTranslator();
  const faq = useRetailerHomePage('faq');
  // const questions = X.useMemo(() => {

  //   return data.questions.map(({ title, answer }) => {
  //     return {
  //       title: tr(title),
  //       answer: tr(answer),
  //     };
  //   });
  // }, [props.locale]);

  return (
    <section id="faq" className="my-12 xl:my-20 scroll-mt-[120px]">
      <div className="mx-mobile-margin xl:max-w-[808px] xl:mx-auto">
        <ReactMarkdown components={{
          p: ({ ...props }) => <h2 {...props} className="text-[26px] xl:text-[48px] [&_strong]:font-medium center mb-6 text-center" />
        }}>
          {faq.title}
        </ReactMarkdown>
        {/* <h2 className="text-[26px] xl:text-[48px] [&_strong]:font-medium center mb-6 text-center">
          {tr({
            en: <><strong>Frequently</strong> Asked Questions</>,
            fr: <>Vos questions <strong>fréquentes</strong></>,
          })}
        </h2> */}
        <X.Questions
          locale={props.locale}
          questions={faq.questions}
        // questions={questions}
        />
        <div className="flex flex-col justify-center items-start xl:items-center mt-10">
          <X.Button
            secondary
            desktopLg
            href="/retail/faq"
            label={faq.showMoreCta}
          // label={tr({
          //   en: "See all questions",
          //   fr: "Voir toutes les questions",
          // })}
          />
        </div>
      </div>
    </section>
  );
}
